import useFetchApi from "@/api/hooks/useFetchApi";
import Accordion from "@/components/Accordion/Accordion2Row";
import BreadCrumb from "@/components/BreadCrumb";
import BlogCard from "@/components/Cards/BlogCard";
import Loader from "@/components/Loader/loader";
import React from "react";


const AboutUs: React.FC = () => {

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/gp/677e69302d638d2cfc865a3a/tr/677e439f2cbec1bd20098b88/detail?list_related=true",
        service: "CMS_PROC"
    });

    return (
        <>
            <BreadCrumb title="Hakkımızda" parent="Kurumsal" child="Hakkımızda" />
            {(isLoading === false && data) ? (
                <>
                    <section className="ls section_padding_top_50 section_padding_bottom_145">
                        <div className="container">


                            <div className="row columns_padding_25">
                                <div className="col-md-3">
                                    <img src={data?.resim} />
                                </div>
                                <div className="col-md-9">
                                    <p className="entry-excerpt highlight2 topmargin_40 bottommargin_30">
                                        <a>{data?.title}</a>
                                    </p>
                                    <p
                                        dangerouslySetInnerHTML={{ __html: data?.content }}>
                                    </p>
                                </div>
                            </div>

                            <div className="row topmargin_10 bottommargin_30">
                                {
                                    data && Array.apply(null, Array((Math.floor(data?.related?.length / 4)))).map((r, i: number) => {
                                        return (
                                            <div className="col-md-6 col-sm-6" key={"about-us-related-hizmet-" + i}>
                                                <ul className="list2">
                                                    {
                                                        data?.related?.filter((x: any) => x.title?.includes("hizmet"))
                                                            .slice(
                                                                i * 4,
                                                                (i + 1) * 4
                                                            )
                                                            .map((r: any, index: number) => {
                                                                return (
                                                                    <li key={"related-elements-" + index}>{r.metin1}</li>
                                                                )
                                                            })
                                                    }
                                                </ul>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <hr />
                        </div >
                    </section>
                </>
            ) : <><Loader /></>
            }

        </>
    )
}

export default AboutUs;